import React, { useState, useEffect } from 'react';
import { useAuth } from '../Context/AuthContext';
import { toast } from 'react-toastify';
import CustomCloseButton from '../Components/CustomCloseButton';

import { Container, Row, Col, Modal, Button, Form } from 'react-bootstrap';
import { timestampToHTMLDateInput, currentTimeStamp } from '../HelperFunctions/dateConverters';

import { db } from '../firebase-config';
import { query, where, collection, getDocs, doc, deleteDoc } from 'firebase/firestore';

import { getFunctions, httpsCallable } from "firebase/functions";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faCircleMinus } from '@fortawesome/free-solid-svg-icons';

import { inputMaxLengths } from '../HelperFunctions/InputMaxLengths';

const RequestModal = (props) =>{
  const { setShowSpinner, currentUser } = useAuth();

  const [custName, setCustName] = useState("");
  const [serviceAt, setServiceAt] = useState("");
  const [custPhoneNo, setCustPhoneNo] = useState("");
  const [custEmail, setCustEmail] = useState("");
  const [requestType, setRequestType] = useState("");
  const [typeOfService, setTypeOfService] = useState("");
  const [requestDetails, setRequestDetails] = useState("");
  const [workOrderNo, setWorkOrderNo] = useState("");
  const [customer, setCustomer] = useState("");
  const [customerPurchaseOrder, setCustomerPurchaseOrder] = useState("");
  const [scheduledDate, setScheduledDate] = useState("");
  const [scheduledPriority, setScheduledPriority] =  useState(10);
  const [assignedTechnicians, setAssignedTechnicians] = useState([]);
  const [leadTech, setLeadTech] = useState("");
  const [units, setUnits] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [truckCharge, setTruckCharge] = useState(0.00);
  
  const [quoteNo, setQuoteNo] = useState("");
  const [quoteAmount, setQuoteAmount] = useState(0.00);

  const [hours, setHours] = useState([]);

  const [techToAddHours, setTechToAddHours] = useState("");

  const [emailTooltip, setEmailTooltip] = useState('');

  const [technicians, setTechnicians] = useState([]);
  const [updateOrderButtonStatus, setUpdateOrderButtonStatus] = useState('edit');  // edit or save

  const emailReg = /[A-Za-z0-9._+-]+@[A-Za-z0-9 -]+\.[a-z]{2,}/g;

  useEffect(()=>{
      setShowSpinner(true);
      let tempTechnicians = [];
      // also get access none, for historical workorders
      const q = query(collection(db, "technicians"), where("access", "==", "technician"));
      getDocs(q).then((querySnapshot)=>{
      //getDocs(collection(db, "technicians")).then((querySnapshot)=>{
          setShowSpinner(false);
          querySnapshot.forEach((doc) => {
              // doc.data() is never undefined for query doc snapshots
              tempTechnicians = [...tempTechnicians, {id: doc.id, data: doc.data()}];
          });
          console.log(tempTechnicians)
      }).then(()=>{
          setTechnicians(tempTechnicians);
      }).catch((error)=>{
          setShowSpinner(false);
          toast.error(`Failed to load data: ${error.message}`);
      });
  }, [setShowSpinner]);

  useEffect(()=>{
    setCustName(props?.request?.data?.work_order?.cust_auth_contact === undefined ? props?.request?.data?.["client name"] === undefined ? "" : props?.request?.data?.["client name"] : props?.request?.data?.work_order?.cust_auth_contact);
    setServiceAt(props?.request?.data?.work_order?.service_at === undefined ? props?.request?.data?.address === undefined ? "" : props.request.data.address : props?.request?.data?.work_order?.service_at);
    setCustPhoneNo(props?.request?.data?.work_order?.phone_number === undefined ? props?.request?.data?.['phone number'] === undefined ? "" : props?.request?.data?.['phone number'] : props?.request?.data?.work_order?.phone_number);
    setCustEmail(props?.request?.data?.work_order?.email_address === undefined ? props?.request?.data?.['email address'] === undefined ? "" : props?.request?.data?.['email address'] : props?.request?.data?.work_order?.email_address);
    setRequestType(props?.request?.data?.work_order?.request_type === undefined ? props?.request?.data?.type === undefined ? "" : props?.request?.data?.type : props?.request?.data?.work_order?.request_type);
    setTypeOfService(props?.request?.data?.work_order?.type_of_service === undefined ? props?.request?.data?.['type of service'] === undefined ? "" : props?.request?.data?.['type of service'] : props?.request?.data?.work_order?.type_of_service);
    setRequestDetails(props?.request?.data?.work_order?.details === undefined ? props?.request?.data?.details === undefined ? "" : props?.request?.data?.details : props?.request?.data?.work_order?.details);
    setWorkOrderNo(props?.request?.data?.work_order?.order_number === undefined ? '' : props?.request?.data?.work_order?.order_number);
    setCustomer(props?.request?.data?.work_order?.customer === undefined ? '' : props?.request?.data?.work_order?.customer);
    setCustomerPurchaseOrder(props?.request?.data?.work_order?.customer_purchase_order === undefined ? '' : props?.request?.data?.work_order?.customer_purchase_order);
    setScheduledDate(props?.request?.data?.work_order?.scheduled_date === undefined ? "" : timestampToHTMLDateInput(props?.request?.data?.work_order?.scheduled_date));
    setScheduledPriority(props?.request?.data?.work_order?.priority === undefined ? 10 : props?.request?.data?.work_order?.priority);
    setAssignedTechnicians(props?.request?.data?.work_order?.assigned_techs === undefined ? [] : props?.request?.data?.work_order?.assigned_techs);
    setLeadTech(props?.request?.data?.work_order?.lead_tech === undefined ? '' : props?.request?.data?.work_order?.lead_tech);
    setUnits(props?.request?.data?.work_order?.units === undefined ? [] : props?.request?.data?.work_order?.units);
    setMaterials(props?.request?.data?.work_order?.materials === undefined ? [] : props?.request?.data?.work_order?.materials);
    setTruckCharge(props?.request?.data?.work_order?.truck_charge === undefined ? 0.00 : props.request.data.work_order.truck_charge);
    setHours(props?.currentworkorderhours === undefined ?  [] : props.currentworkorderhours);
    setQuoteNo(props?.request?.data?.work_order?.quote_number === undefined ? '' : props?.request?.data?.work_order?.quote_number);
    setQuoteAmount(props?.request?.data?.work_order?.quote_amount === undefined ||  props?.request?.data?.work_order?.quote_amount === "" ? 0.00 : props?.request?.data?.work_order?.quote_amount);
  },[props]);

  const updateAssignedTechnicians = (event)=>{
    // console.log(event.target.selectedOptions)
    setAssignedTechnicians([].slice.call(event.target.selectedOptions).map(item => item.value));
    if(event.target.selectedOptions.length === 0){
      setLeadTech('');
      return null;
    }
    if(event.target.selectedOptions.length === 1){
      setLeadTech(event.target.selectedOptions[0].value);
      return null;
    }
    if(![].slice.call(event.target.selectedOptions).find(tech => tech.value === leadTech)){
      setLeadTech([].slice.call(event.target.selectedOptions)[0].value);
      return null;
    }
  };
  const addUnits = () => {
    let tempUnits = [...units];
    tempUnits.unshift({
      Make: '',
      Model: '',
      Serial: '',
      'Description of Work Performed': '',
      'Service Recommended': '',
    });
    setUnits(tempUnits);
  };
  const removeUnits = (index) => {
    let tempUnits = [...units];
    tempUnits.splice(index, 1);
    setUnits(tempUnits);
  };

  const updateUnits = (unit, field, value)=>{
    let tempUnits = [...units];
    let tempUnit = {
      ...tempUnits[unit],
      [field]: value,
    };
    tempUnits[unit] = tempUnit;
    setUnits(tempUnits);
  };
  const addMaterials = () => {
    let tempMaterials = [...materials];
    tempMaterials.unshift({Source: '', Qty: '', 'Material Description': '', 'Price': ''});
    setMaterials(tempMaterials);
  };
  const removeMaterials = (index) => {
    let tempMaterials = [...materials];
    tempMaterials.splice(index, 1);
    setMaterials(tempMaterials);
  };
  const updateMaterials = (material, field, value)=>{
    let tempMaterials = [...materials];
    let tempMaterial = {
      ...tempMaterials[material],
      [field]: value,
    };
    tempMaterials[material] = tempMaterial;
    setMaterials(tempMaterials);
  };

  const addHours = ()=>{
    // later update setCurrentWorkOrderHours on the maint screen after saving
    console.log(hours)
    let tempHours = [...hours];
    tempHours.push({
      Monday: "",
      Tuesday: "",
      Wednesday: "",
      Thursday: "",
      Friday: "",
      Saturday: "",
      Sunday: "",
      'Monday Rate': "",
      'Tuesday Rate': "",
      'Wednesday Rate': "",
      'Thursday Rate': "",
      'Friday Rate': "",
      'Saturday Rate': "",
      'Sunday Rate': "",
      order_number: workOrderNo,
      requestID: props.request.id,
      techID: techToAddHours,
      last_saved: {
        at: currentTimeStamp(),
        by: currentUser.email,
      },
    });
    // console.log(tempHours);
    setHours(tempHours);
  };
  const removeHours = (index)=>{
    let tempHours = [...hours];
    tempHours.splice(index, 1);
    setHours(tempHours);
  };
  const updateTechHours = (index, field, value)=> {
    let tempHours = [...hours];
    tempHours[index] = {...hours[index],
      [field]: value,
    };
    setHours(tempHours);
  };

  const updateTechRateHours = (index, defaultHoursObject)=>{
    let tempHours = [...hours];
    tempHours[index] = {...hours[index],
      'Monday Rate': defaultHoursObject?.Monday,
      'Tuesday Rate': defaultHoursObject?.Tuesday,
      'Wednesday Rate': defaultHoursObject?.Wednesday,
      'Thursday Rate': defaultHoursObject?.Thursday,
      'Friday Rate': defaultHoursObject?.Friday,
      'Saturday Rate': defaultHoursObject?.Saturday,
      'Sunday Rate': defaultHoursObject?.Sunday,
    };
    setHours(tempHours);
  };

  const restore = (requestID)=>{
    if(requestID === undefined){
      toast.warn('Request ID does not exist, cannot restore deleted request.');
      return null;
    }
    if(props?.request?.data === undefined){
      toast.warn('Request does not exist, cannot restore deleted request.');
      return null;
    }
    setShowSpinner(true);
    const functions = getFunctions();
    const restoreRequest = httpsCallable(functions, 'recoverRequest');
    restoreRequest({
      info: props.request.data,
      docID: requestID
    }).then(async (response)=>{
      setShowSpinner(false);
      if(response.data.info === 'request recovered'){
        toast.success(`Request has been restored, please go to Dashboard to see restored request.`);
        try{
          await deleteDoc(doc(db, "deleted_work_orders", requestID));
          props.onHide('none', 'none');
        }catch{
          toast.error(`Could not remove the deleted copy, please try again. If error persists please contact admin.`);
        }
      }else{
        console.log(response);
        toast.error(`Could not restore request. Please contact admin.`);
      }
    }).catch((error)=>{
      setShowSpinner(false);
      toast.error(`Could not restore request. Please contact admin.`);
    });
  };

  return(
    <Modal
      {...props}
      size="xl"
      // fullscreen
      animation={false}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>{props?.request?.data?.type.toUpperCase()}: {props?.request?.data?.work_order?.service_at === undefined ? props?.request?.data?.address : props?.request.data.work_order.service_at} - {props?.request?.data?.work_order?.order_number === undefined ? props?.request?.data?.["client name"] : props?.request?.data?.work_order?.order_number === '' ? props?.request?.data?.["client name"] : props?.request?.data?.work_order?.order_number}</Modal.Title>
        <div onClick={()=>{
          setUpdateOrderButtonStatus('edit');
          props.onHide('show cancel', updateOrderButtonStatus)
          }}>
              <CustomCloseButton />
          </div>
      </Modal.Header>
      <Modal.Body>
        <Container fluid style={{marginTop:"20px"}}>
          <Row>
            <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
              <Row style={{marginBottom: "20px"}}><Col>GENERAL INFORMATION</Col></Row>
              <Row style={{marginLeft: "20px", marginTop:"10px"}}>
                  <Col>
                      Status: 
                      {props?.request?.data?.status === 1 && ' NEW REQUEST'}
                      {props?.request?.data?.status === 2 && ' CREATED WORK ORDER'}
                      {props?.request?.data?.status === 3 && ' SCHEDULED WORK ORDER'}
                      {props?.request?.data?.status === 4 && ' COMPLETED WORK ORDER'}
                      {props?.request?.data?.status === 5 && ' FINALIZED WORK ORDER'}
                  </Col>
              </Row>
              <Row style={{marginLeft: "20px", marginTop:"10px", width:"400px"}}><Col>Service At:</Col><Col><a href={`https://www.google.com/maps/place/${serviceAt}`} target="_blank" rel="noreferrer">View Map</a></Col></Row>
            </Col>
            <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
              <Row style={{marginBottom: "20px"}}><Col>ACTION BUTTONS</Col></Row>
              <Row>
                <Col lg="4">
                  {<Button
                    className="btn-dark"
                    style={{backgroundColor:"#2596be", margin:5}}
                    onClick={()=>{
                      if(props?.request?.data?.status === 1){
                          if(window.confirm(`Are you sure you want to retore work order ${props?.request?.data?.["client name"]}`)){
                            restore(props?.request?.id);
                          }
                      }else{
                          if(window.confirm(`Are you sure you want to restore work order ${workOrderNo}`)){
                              restore(props?.request?.id);
                          }
                      }
                    }}
                    >
                      Restore
                  </Button>}
                </Col>
                <Col lg="4">
                  {
                    updateOrderButtonStatus === 'save' ?
                      <Button
                        className="btn-dark"
                        style={{backgroundColor:"#2596be", margin:5}}
                        onClick={()=>{
                          setUpdateOrderButtonStatus('edit');
                          props.onHide('show cancel', updateOrderButtonStatus);
                        }}
                      >
                        Cancel
                      </Button>
                    :
                        <div></div>
                }
                </Col>
                
              </Row>
            </Col>
          </Row>
          
          
          <Row>
            <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
              <Row style={{marginBottom: "20px"}}><Col>REQUEST DETAILS</Col></Row>
              
              <Row style={{marginLeft:"10px"}}><Col>SERVICE AT:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.address} disabled /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>CUST. PHONE No.</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.['phone number']} disabled /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.["client name"]} disabled /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT EMAIL ADDRESS:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.['email address']} disabled /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>REQUEST TYPE:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.type} disabled /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>TYPE OF SERVICE:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.type === 'quote' ? '' : props?.request?.data?.['type of service']} disabled /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>Details:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={props?.request?.data?.details} rows={4} disabled /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>REQUEST DATE: {timestampToHTMLDateInput(props?.request?.data?.timestamp)}</Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>ID: {props?.request?.id}</Col></Row>
            </Col>
            <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
              <Row style={{marginBottom: "20px"}}>
                <Col>
                  {
                    props?.request?.data?.status === 1 ? "DISPATCH - CREATE WORK ORDER" : "WORK ORDER"
                  }
                </Col>
              </Row>
              
              <Row style={{marginLeft:"10px"}}><Col>SERVICE AT:*</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={serviceAt} maxLength={inputMaxLengths.serviceAt} onChange={(e)=> setServiceAt(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>CUST. PHONE No.*</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={custPhoneNo} maxLength={inputMaxLengths.custPhoneNo} onChange={(e)=> setCustPhoneNo(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT:*</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={custName} maxLength={inputMaxLengths.custAuthContact} onChange={(e)=> setCustName(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT EMAIL ADDRESS:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                <Col>
                  <Form.Control
                    type="text"
                    value={custEmail}
                    onChange={(e)=> {
                      if (emailReg.test(e.target.value) === false && e.target.value !== '') {
                        setEmailTooltip('Not a valid email format, must have an @ sign and a .');
                      } else {
                          setEmailTooltip('');
                      }
                      setCustEmail(e.target.value)
                    }}
                    required
                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                  />
                </Col>
              </Row>
              <Row style={{color:'red', display:'flex', justifyContent:'center'}}>{emailTooltip}</Row>
              <Row style={{marginLeft:"10px"}}><Col>REQUEST TYPE:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                {requestType === 'maintenance' && 
                    <Col>
                      <Form.Select as="select" value={requestType} onChange={(e)=> setRequestType(e.target.value)} required disabled={true} >
                        <option value={'maintenance'}>maintenance</option>
                      </Form.Select>
                    </Col>
                  }
                  {(requestType === 'service' || requestType === 'quote') && 
                    <Col>
                      <Form.Select as="select" value={requestType} onChange={(e)=> setRequestType(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} >
                        <option value={'service'}>service</option>
                        <option value={'quote'}>quote</option>
                      </Form.Select>
                    </Col>
                  }
              </Row>
              <Row style={{marginLeft:"10px"}}><Col>TYPE OF SERVICE:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
              {requestType === 'maintenance' && 
                    <Col>
                      <Form.Select as="select" value={typeOfService} onChange={(e)=> setTypeOfService(e.target.value)} required disabled={(updateOrderButtonStatus === 'edit' || requestType === 'quote') ? true : false} >
                        <option value={''}></option>
                        <option value={'Heating'}>Heating</option>
                        <option value={'Cooling'}>Cooling</option>
                        <option value={'Other (please provide details)'}>Other (please provide details)</option>
                      </Form.Select> 
                    </Col>
                  }
                  {(requestType === 'service' || requestType === 'quote') && 
                    <Col>
                      <Form.Select as="select" value={requestType === 'quote' ? '' : typeOfService} onChange={(e)=> setTypeOfService(e.target.value)} required disabled={(updateOrderButtonStatus === 'edit' || requestType === 'quote') ? true : false} >
                        <option value={''}></option>
                        <option value={'No Heat'}>No Heat</option>
                        <option value={'No AC'}>No AC</option>
                        <option value={'Other (please provide details)'}>Other (please provide details)</option>
                      </Form.Select> 
                    </Col>
                  }
              </Row>
              <Row style={{marginLeft:"10px"}}><Col>Details:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={requestDetails} maxLength={inputMaxLengths.details} onChange={(e)=>{setRequestDetails(e.target.value)}} rows={4} disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{display:'flex', justifyContent:'center'}}>{inputMaxLengths?.details - requestDetails?.length} characters remaining</Row>
              <Row style={{marginLeft:"10px"}}><Col>WORK ORDER No:*</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={workOrderNo} maxLength={inputMaxLengths.workorderNumber} onChange={(e)=> setWorkOrderNo(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>QUOTE:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={quoteNo} maxLength={inputMaxLengths.quoteNumber} onChange={(e)=> setQuoteNo(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>QUOTE AMT $:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" value={quoteAmount} maxLength={inputMaxLengths.quoteNumber} onChange={(e)=> {
                  if(e.target.value === ""){
                    setQuoteAmount('')
                  }else{
                    setQuoteAmount(parseFloat(e.target.value))
                  }
                }}required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>CUSTOMER:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={customer} maxLength={inputMaxLengths.customer} onChange={(e)=> setCustomer(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{marginLeft:"10px"}}><Col>CUSTOMER PURCHASE ORDER:</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={customerPurchaseOrder} maxLength={inputMaxLengths.purchaseOrder} onChange={(e)=> setCustomerPurchaseOrder(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              
              <Row style={{marginLeft: "10px"}}><Col>DISPATCHED DATE: yyyy-mm-dd</Col></Row>
              <Row style={{marginLeft: "10px", maxWidth:"200px"}}><Col><Form.Control type="date" value={scheduledDate} onChange={(e)=> setScheduledDate(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{marginLeft: "10px", marginTop:"10px"}}><Col>PRIORITY:</Col></Row>
              <Row style={{marginLeft: "10px", maxWidth:"100px"}}><Col><Form.Control type="number" min="1" max="10" value={scheduledPriority} onChange={(e)=> setScheduledPriority(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
              <Row style={{marginLeft:"10px", marginTop:"10px"}}><Col>ASSIGNED TECHNICIANS: {assignedTechnicians.length}</Col></Row>
              <Row style={{marginLeft:"20px", marginBottom:"10px", maxWidth:"300px"}}>
                <Form.Control as="select" multiple value={assignedTechnicians} onChange={e => updateAssignedTechnicians(e)} disabled={updateOrderButtonStatus === 'edit' ? true : false} >
                    {
                      technicians.map((tech)=>{
                        return(
                          <option key={tech.id} value={tech.id}>{tech.data.tech_name}</option>
                        )
                      })
                    }
                </Form.Control>
              </Row>
              <Row style={{marginLeft:"10px", marginTop:"10px"}}><Col>LEAD TECHNICIAN</Col></Row>
              <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                <Col>
                  <Form.Select as="select" value={leadTech} onChange={(e)=> setLeadTech(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} >
                    <option value={``}>{``}</option>
                    {
                      assignedTechnicians.map((tech)=>{
                        return(
                          technicians.find(searchTech=>searchTech.id === tech) !== undefined &&
                          <option
                            key={tech}
                            value={tech}
                          >
                            {
                              technicians.find(searchTech=>searchTech.id === tech).data.tech_name
                            }
                          </option>
                        )
                      })
                    }
                  </Form.Select>
                </Col>
              </Row>
              <Row style={{marginLeft: "10px", marginTop:"10px"}}><Col>LAST UPDATED: {props?.request?.data?.work_order?.last_saved?.at !== undefined ? timestampToHTMLDateInput(props.request.data.work_order.last_saved.at) : ""}</Col></Row>
              <Row style={{marginLeft: "10px"}}><Col>BY: {props?.request?.data?.work_order?.last_saved?.by !== undefined ? props.request.data.work_order.last_saved.by : ""}</Col></Row>
            </Col>
          </Row>
          <Row>
            <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
              <Row style={{marginBottom: "20px"}}>
                <Col>
                  WORK PERFORMED (Units: {units?.length})
                  {
                    updateOrderButtonStatus === 'save' ?
                      <Button
                        className="btn-dark"
                        style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                        onClick={()=>{
                          addUnits();
                        }}
                        >
                        <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                      </Button>
                    :
                      ""
                  }
                </Col>
              </Row>
              {
                units.map((unit, index)=>{
                  return(
                    <Row key={index} style={{margin: 20}}>
                      <Row>
                        UNIT {index+1}
                        {
                          updateOrderButtonStatus === 'save' ?
                            <Button
                              className="btn-dark"
                              style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                              onClick={()=>{
                                if(window.confirm(`Are you sure you want to delete UNIT ${index+1}`)){
                                  removeUnits(index);
                                }
                              }}
                              >
                              <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                            </Button>
                          :
                            ""
                        }
                      </Row>
                      <Row><Col>MAKE:</Col></Row>
                      <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={unit?.["Make"]} maxLength={inputMaxLengths.make} onChange={(e)=> updateUnits(index, 'Make', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      <Row><Col>MODEL:</Col></Row>
                      <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={unit?.["Model"]} maxLength={inputMaxLengths.model} onChange={(e)=> updateUnits(index, 'Model', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      <Row><Col>SERIAL:</Col></Row>
                      <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={unit?.["Serial"]} maxLength={inputMaxLengths.serial} onChange={(e)=> updateUnits(index, 'Serial', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      <Row><Col>DESCRIPTION OF WORK PERFORMED:</Col></Row>
                      <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={unit?.["Description of Work Performed"]} onChange={(e)=> updateUnits(index, 'Description of Work Performed', e.target.value)} rows={8} disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      <Row><Col>SERVICE RECOMMENDED:</Col></Row>
                      <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={unit?.["Service Recommended"]} onChange={(e)=> updateUnits(index, 'Service Recommended', e.target.value)} rows={3} disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                    </Row>
                  )
                })
              }
            </Col>
          </Row>
          <Row>
            <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
              <Row style={{marginBottom: "20px"}}>
                <Col>
                  MATERIALS (Entries: {materials?.length})
                  {
                    updateOrderButtonStatus === 'save' ?
                      <Button
                        className="btn-dark"
                        style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                        onClick={()=>{
                          addMaterials();
                        }}
                        >
                        <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                      </Button>
                    :
                      ""
                  }
                </Col>
              </Row>
              {
                materials.map((material, index)=>{
                  return(
                    <Row key={index} style={{margin: 20}}>
                      <Row>
                        MATERIAL {index+1}
                        {
                          updateOrderButtonStatus === 'save' ?
                            <Button
                              className="btn-dark"
                              style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                              onClick={()=>{
                                if(window.confirm(`Are you sure you want to delete MATERIAL ${index+1}`)){
                                  removeMaterials(index);
                                }
                              }}
                              >
                              <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                            </Button>
                          :
                            ""
                        }
                      </Row>
                      <Row><Col>SOURCE:</Col></Row>
                      <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={material?.["Source"]} maxLength={inputMaxLengths.source} onChange={(e)=> updateMaterials(index, 'Source', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      <Row><Col>QTY:</Col></Row>
                      <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" min="0" value={material?.["Qty"]} maxLength={inputMaxLengths.qty} onChange={(e)=> updateMaterials(index, 'Qty', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      <Row><Col>MATERIAL DESCRIPTION:</Col></Row>
                      <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={material?.["Material Description"]} maxLength={inputMaxLengths.materialDescription} onChange={(e)=> updateMaterials(index, 'Material Description', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      <Row><Col>PRICE:</Col></Row>
                      <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" min="0" value={material?.["Price"]} onChange={(e)=> updateMaterials(index, 'Price', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                    </Row>
                  )
                })
              }
            </Col>
          </Row>
          <Row>
            <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
              <Row style={{marginBottom: "20px"}}>
                <Col>TRUCK CHARGE</Col>
                <Col>{
                  updateOrderButtonStatus === 'save' ?
                    <Button
                      className="btn-dark"
                      style={{backgroundColor:"#2596be"}}
                      onClick={()=>{
                        setTruckCharge(props.defaulttruckcharge);
                        toast.info(`Truck Rate Field updated to ${props.defaulttruckcharge}, Save work order to confirm.`);
                      }}
                    >
                      Load Default Truck Charge
                    </Button>
                  :
                    ""
                }</Col>
              </Row>
              <Form.Control style={{marginLeft:20, width:200}} type="number" min="0" value={truckCharge} onChange={(e)=> setTruckCharge(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} />
            </Col>
          </Row>
          <Row>
            <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
              <Row style={{marginBottom: "20px"}}>
                <Col>
                  HOURS (Techs: {hours.filter(tech => assignedTechnicians.includes(tech.techID)).length} of {assignedTechnicians.length})
                  {
                    updateOrderButtonStatus === 'save'  && assignedTechnicians.length > 0 && hours.filter(tech => assignedTechnicians.includes(tech.techID)).length < assignedTechnicians.length ?
                      <Button
                        className="btn-dark"
                        style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                        onClick={()=>{
                          if(techToAddHours !== "" && techToAddHours !== undefined){
                            addHours();
                          }else{
                            toast.warning('Please select a tech from the drop down');
                          }
                        }}
                        >
                        <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                      </Button>
                    :
                      ""
                  }
                  </Col>
                  <Col>
                  {
                    updateOrderButtonStatus === 'save'  && assignedTechnicians.length > 0 && hours.filter(tech => assignedTechnicians.includes(tech.techID)).length < assignedTechnicians.length ?
                      <Form.Select as="select" style={{width:400}} value={techToAddHours} onChange={(e)=> setTechToAddHours(e.target.value) } >
                        <option value={``}>{``}</option>
                        {
                          assignedTechnicians.map((tech)=>{
                            return(
                              <option
                                key={tech}
                                value={tech}
                              >
                                {
                                  hours.filter(e => e.techID === tech).length === 0 &&
                                    technicians.find(searchTech=>searchTech.id === tech).data.tech_name
                                }
                              </option>
                            )
                          })
                        }
                      </Form.Select>
                    :
                      ""
                  }
                </Col>
              </Row>
              {
                hours.map((tech, index)=>{
                  return(
                    assignedTechnicians.includes(tech.techID) ?
                      <Row key={index} style={{marginTop: 20}}>
                        <Row style={{margin: 10}}>
                          <Col>
                            {index + 1}. {technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name}
                            {
                              updateOrderButtonStatus === 'save' ?
                                <Button
                                  className="btn-dark"
                                  style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                                  onClick={()=>{
                                    if(window.confirm(`Are you sure you want to delete HOURS for ${technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name}`)){
                                      removeHours(index);
                                    }
                                  }}
                                  >
                                  <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                                </Button>
                              :
                                ""
                            }
                          </Col>
                          <Col>{
                            updateOrderButtonStatus === 'save' ?
                              <Button
                                className="btn-dark"
                                style={{backgroundColor:"#2596be"}}
                                onClick={()=>{
                                  updateTechRateHours(index, props.defaultdailyrates)
                                  toast.info(`Daily Rates for this ${technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name} have been updated, Save work order to confirm.`);
                                }}
                              >
                                Load Default Daily Rates
                              </Button>
                            :
                              ""
                          }
                          </Col>
                        </Row>
                        <Row style={{margin: 5}}>
                          <Col>
                            <Row style={{maxWidth:300}}>
                              <Col style={{textAlign:"right"}}>Monday:</Col>
                              <Col>
                                <Form.Control
                                  style={{marginLeft:0,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Monday', e.target.value)
                                  }}
                                  value={tech?.Monday}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                                </Col>
                              </Row>
                            </Col>
                          <Col>
                            <Row>
                              Rate: <Form.Control
                                style={{marginLeft:20,width:100}}
                                type="number"
                                min="0"
                                onChange={(e)=>{
                                  updateTechHours(index, 'Monday Rate', e.target.value)
                                }}
                                value={tech?.["Monday Rate"]}
                                disabled={updateOrderButtonStatus === 'edit' ? true : false}
                              />
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{margin: 5}}>
                          <Col>
                            <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Tuesday:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:100}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Tuesday', e.target.value)
                                    }}
                                    value={tech?.Tuesday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false} 
                                  />
                                </Col>
                              </Row>
                            </Col>
                          <Col>
                            <Row>Rate: <Form.Control
                                style={{marginLeft:20,width:100}}
                                type="number"
                                min="0"
                                onChange={(e)=>{
                                  updateTechHours(index, 'Tuesday Rate', e.target.value)
                                }}
                                value={tech?.["Tuesday Rate"]}
                                disabled={updateOrderButtonStatus === 'edit' ? true : false} 
                              />
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{margin: 5}}>
                          <Col>
                            <Row style={{maxWidth:300}}>
                              <Col style={{textAlign:"right"}}>Wednesday:</Col>
                              <Col>
                                <Form.Control
                                  style={{marginLeft:0,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Wednesday', e.target.value)
                                  }}
                                  value={tech?.Wednesday}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col>
                            <Row>Rate: <Form.Control
                                style={{marginLeft:20,width:100}}
                                type="number"
                                min="0"
                                onChange={(e)=>{
                                  updateTechHours(index, 'Wednesday Rate', e.target.value)
                                }} 
                                value={tech?.["Wednesday Rate"]}
                                disabled={updateOrderButtonStatus === 'edit' ? true : false}
                              />
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{margin: 5}}>
                          <Col>
                            <Row style={{maxWidth:300}}>
                              <Col style={{textAlign:"right"}}>Thursday:</Col>
                              <Col>
                                <Form.Control
                                  style={{marginLeft:0,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Thursday', e.target.value)
                                  }}
                                  value={tech?.Thursday}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col>
                            <Row>Rate: <Form.Control
                                style={{marginLeft:20,width:100}}
                                type="number"
                                min="0"
                                onChange={(e)=>{
                                  updateTechHours(index, 'Thursday Rate', e.target.value)
                                }}
                                value={tech?.["Thursday Rate"]}
                                disabled={updateOrderButtonStatus === 'edit' ? true : false}
                              />
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{margin: 5}}>
                          <Col>
                            <Row style={{maxWidth:300}}>
                              <Col style={{textAlign:"right"}}>Friday:</Col>
                              <Col>
                                <Form.Control
                                  style={{marginLeft:0,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Friday', e.target.value)
                                  }}
                                  value={tech?.Friday}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col>
                            <Row>Rate: <Form.Control
                                style={{marginLeft:20,width:100}}
                                type="number"
                                min="0"
                                onChange={(e)=>{
                                  updateTechHours(index, 'Friday Rate', e.target.value)
                                }}
                                value={tech?.["Friday Rate"]}
                                disabled={updateOrderButtonStatus === 'edit' ? true : false}
                              />
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{margin: 5}}>
                          <Col>
                            <Row style={{maxWidth:300}}>
                              <Col style={{textAlign:"right"}}>Saturday:</Col>
                              <Col>
                                <Form.Control
                                  style={{marginLeft:0,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Saturday', e.target.value)
                                  }}
                                  value={tech?.Saturday}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col>
                            <Row>Rate: <Form.Control
                                style={{marginLeft:20,width:100}}
                                type="number"
                                min="0"
                                onChange={(e)=>{
                                  updateTechHours(index, 'Saturday Rate', e.target.value)
                                }}
                                value={tech?.["Saturday Rate"]}
                                disabled={updateOrderButtonStatus === 'edit' ? true : false}
                              />
                            </Row>
                          </Col>
                        </Row>
                        <Row style={{margin: 5}}>
                          <Col>
                            <Row style={{maxWidth:300}}>
                              <Col style={{textAlign:"right"}}>Sunday:</Col>
                              <Col>
                                <Form.Control
                                  style={{marginLeft:0,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Sunday', e.target.value)
                                  }}
                                  value={tech?.Sunday}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col>
                            <Row>Rate: <Form.Control
                                style={{marginLeft:20,width:100}}
                                type="number"
                                min="0"
                                onChange={(e)=>{
                                  updateTechHours(index, 'Sunday Rate', e.target.value)
                                }}
                                value={tech?.["Sunday Rate"]}
                                disabled={updateOrderButtonStatus === 'edit' ? true : false}
                              />
                            </Row>
                          </Col>
                        </Row>
                      </Row>
                    :
                      <div key={index}></div>
                  )
                })
              }
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          className="btn-dark"
          style={{backgroundColor:"#2596be"}}
          onClick={()=>{
              setUpdateOrderButtonStatus('edit');
              props.onHide('show cancel', updateOrderButtonStatus);
          }}
        >
          {updateOrderButtonStatus === 'edit' ? "Close" : "Cancel and Close"}
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

export default RequestModal;